<template>
  <div class="step3">
    <!-- ケーキのサイズについて -->
    <div class="noticeSize">
      ホールケーキのサイズについて
      <ul>
        <li>４号：２〜３名様分の小さなケーキ</li>
        <li>５号：４〜６名様分の標準的なサイズ</li>
        <li>６号：７〜１０名様分の少し大きめサイズ</li>
        <!-- <li>７号：１１〜１４名様分の大きめサイズ</li> -->
      </ul>
    </div>
    <small class="not-display-soldout">※完売した商品は表示されません</small>
    <!-- /ケーキのサイズについて -->

    <div class="step3--main">
      <!--非表示-->
      <div class="selectCat" v-show="false">
        <p class="selectCat__text1">カテゴリーで絞り込む</p>
        <div class="selectCatBtnBox">
          <!-- <button class="category" id="catAll" @click="selectAll">全商品</button> -->
          <button
            v-for="(cat, index) in category"
            :key="index"
            class="category catBtn"
            @click="selectCat(cat.id, cat.name)"
            v-bind:id="cat.name"
          >
            {{ cat.name }}
          </button>
        </div>
      </div>

      <!--商品リスト-->
      <div class="itemList">
        <!--商品-->
        <div
          v-for="(item, index) in reservation.showItemList"
          :key="index"
          v-bind:class="item._embedded['wp:term'][0][0].name"
          class="itemBox"
          @click="
            openModal(item, index);
            showCartContents(item);
          "
        >
          <p class="itemBox--imgBlock" v-bind:id="['item' + index]">
            <img
              v-bind:src="item.acf.images[0].image.sizes.medium"
              class="itemBox--imgBlock--img"
            /><i class="fas fa-plus"></i>
          </p>
          <!-- <p class="itemBox--categoryName">{{ item._embedded['wp:term'][0][0].name }}</p> -->
          <p class="itemBox--itemName text-center">{{ item.title.rendered }}</p>
          <p class="itemBox--itemPrice text-center">
            {{ item.min_price | calcTax | addComma }}円(税込)〜
          </p>
        </div>
        <div class="itemBox none"></div>
        <div class="itemBox none"></div>
        <div class="itemBox none"></div>
        <div class="itemBox none"></div>
        <p class="mr-auto ml-auto mt-4" v-if="seenNoItemtext">
          指定された日時ではご用意できる商品がありません。
        </p>
      </div>
    </div>

    <!--カートモーダル-->
    <div class="modal_cart" id="modalCart">
      <div class="modal_cart_white">
        <p class="stopButton" id="stopButtonCart" @click="closePopUpCart">
          <i class="fas fa-times"></i>
        </p>
        <div class="step3--cart" v-if="seenCart">
          <p class="step3--cart__title">カートの中身</p>
          <div
            v-for="(itemCart, index) in reservation.cart"
            :key="index"
            class="step3--cart--list"
          >
            <p class="step3--cart--list__img">
              <img v-bind:src="itemCart.image" style="max-width:100%;" />
            </p>
            <div class="step3--cart--list__price">
              <p>{{ itemCart.name }}</p>
              <p>
                {{ itemCart.price | calcTax | addComma }}円（税別）<br
                  class="d-block d-md-none"
                />{{ itemCart.number }}個
              </p>
              <!--ろうそくの本数・メッセージ（出し分け）-->
            </div>
            <p class="hiddenSum">{{ itemCart.price * itemCart.number }}</p>
            <p
              class="step3--cart--list__dele"
              @click="
                deleCartItem(index);
                hideCart();
              "
            >
              削除
            </p>
          </div>
          <div class="step3--cart__sum">
            <p>小計 {{ reservation.sum | calcTax | addComma }}円</p>
            <p>内税 {{ Math.floor(reservation.sum * 0.08) | addComma }}円</p>
            <p>
              合計 <span>{{ reservation.sum | calcTax | addComma }}円</span>
            </p>
          </div>
          <div class="btnBox">
            <button
              class="btn btn_blue text-center"
              @click="closePopUpCart"
              type="button"
            >
              <i class="fas fa-chevron-left"></i>ショッピングを続ける
            </button>
            <button class="btn text-center" @click="next" type="button">
              お客様情報入力へすすむ<i class="fas fa-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- /カートモーダル -->

    <!--モーダル-->
    <div class="modal" id="modal">
      <div id="modal--whiteBlock">
        <div id="modal--contents" class="modal__contents">
          <p class="stopButton" id="stopButton" @click="closeModal">
            <i class="fas fa-times"></i>
          </p>
          <!--タイトル（商品名）-->
          <p class="modal__contents--itemName">{{ reservation.item.name }}</p>
          <div class="modal--content">
            <!--タイトル（写真部分）-->
            <div class="modal--contentImg">
              <p>
                <img
                  v-bind:src="reservation.item.images.main"
                  class="modal--contentImg--main"
                />
              </p>
              <div class="modal--contentImg--thum">
                <img
                  v-for="(thum, index) in reservation.item.images.thum"
                  :key="index"
                  v-bind:src="thum"
                  v-show="thumDisplay"
                  @click="thumImgClick(thum)"
                />
              </div>
              <p class="mt-2 mt-sm-3 mb-2 mb-sm-3">
                <small
                  >※
                  写真はイメージです。実際のデザインとは異なる場合がございますのでご了承ください。</small
                >
              </p>
            </div>

            <button
              class="btn d-md-none"
              id="cartIn"
              @click="
                cartIn();
                showCart();
              "
            >
              カートに入れる<i class="fas fa-chevron-right"></i>
            </button>

            <!--タイトル（フォーム部分）-->
            <div class="modal--contentForm">
              <div
                class="modal--contentForm__desc"
                v-html="this.reservation.item.desc"
              ></div>

              <!-- サイズ・規格 -->
              <div class="label_kikaku">
                <label
                  v-for="(kikaku, index) in reservation.item.kikaku"
                  :key="index"
                  class="kikakuLabel"
                  @click="radioAddClass(index)"
                  :class="{
                    d_none: isEnough(kikaku),
                    current: labelCurrrentCheck(index),
                  }"
                >
                  <input
                    type="radio"
                    name="kikaku"
                    :value="kikaku.kikaku_size"
                    :checked="labelCurrrentCheck(index)"
                  />
                  <span class="kikakuLabel__txt"
                    >{{ kikaku.kikaku_size }}（
                    {{ kikaku.kikaku_price | calcTax | addComma }}円 )</span
                  >
                </label>
              </div>

              <!-- 個数 -->
              <div class="modal--contentForm__number pt-2">
                <label class="modal--contentForm__number--label">数量</label>
                <input
                  type="number"
                  id="number"
                  min="1"
                  class="modal--contentForm__number--input form-control"
                  value="1"
                  size="3"
                />個
              </div>

              <button
                class="btn d-none d-md-block"
                id="cartIn"
                @click="
                  cartIn();
                  showCart();
                "
              >
                カートに入れる<i class="fas fa-chevron-right"></i>
              </button>
            </div>
            <!-- /タイトル（フォーム部分）-->
          </div>
        </div>
      </div>
    </div>
    <!-- /モーダル -->
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "step3",
  data() {
    return {
      seenNoItemtext: false,
      thumDisplay: true,
    };
  },
  props: [
    "seen",
    "buttonText",
    "step",
    "shops",
    "items",
    "radioResult",
    "reservation",
    "category",
    "seenCart",
    "seenCartContents",
    "AppSum",
  ],
  mounted() {
    this.showNoItemText();
    this.checkSeen();
    this.border();
    // 最初の選択をホールケーキに
    const cat = document.getElementsByClassName("category");
    cat[0].classList.add("active");
  },
  updated() {
    //枠線の付与
    this.border();
    //ラジオボタンのcheckedを付与
    if (document.getElementsByName("kikaku")) {
      let modal_radio = document.getElementsByName("kikaku");
      if (modal_radio[0]) {
        modal_radio[0].checked = true;
      }
    }
    //selectbox(option)の削除
    let option_kikaku = document.getElementsByClassName("option_kikaku");
    for (let i = option_kikaku.length - 1; 0 <= i; --i) {
      //IE対策用
      if (option_kikaku[i].classList.contains("d_none")) {
        option_kikaku[i].parentNode.removeChild(option_kikaku[i]);
      }
    }
    if (document.getElementById("pageHeaderCartBtn")) {
      const pageHeaderCartBtn = document.getElementById("pageHeaderCartBtn");
      if (pageHeaderCartBtn.style.display == "block") {
        const pageHeaderCartBtn_first = document.getElementById(
          "pageHeaderCartBtn_first"
        );
        pageHeaderCartBtn_first.style.display = "none";
      }
    }
  },
  computed: {
    filterdCategoryBySelectedDate: function() {
      // 12/24
      return (
        this.reservation.month == 12 &&
        [24].includes(Number(this.reservation.date))
      );
    },
  },
  computed: {},
  filters: {
    addComma: function(val) {
      return String(val).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
    },
    calcTax: function(num) {
      return Math.trunc(Number(num) * 1.08);
    },
  },
  methods: {
    completeItem(items) {
      return items.filter((item) => {
        if (item.if === 2424) {
          return false;
        } else {
          return true;
        }
      });
    },
    //ステップを次に進める処理
    next: function() {
      this.$emit("next");
    },
    //ステップを前に戻す処理
    prev: function(number) {
      this.$emit("prev", number);
    },
    //枠線の再描画
    border: function() {
      //カートに入っている商品に枠をつける
      if (this.reservation.showItemList.length !== 0) {
        for (let i = 0; i < this.reservation.showItemList.length; i++) {
          if (document.getElementById("item" + i)) {
            let id = "#item" + i;
            let itemBox = $(id);
            itemBox.parent(".itemBox").css("border", "solid 1px #d8d8d8");
          }
        }
        if (this.reservation.cart.length !== 0) {
          for (let i = 0; i < this.reservation.cart.length; i++) {
            for (let j = 0; j < this.reservation.showItemList.length; j++) {
              if (
                this.reservation.cart[i].original ===
                this.reservation.showItemList[j].title.rendered
              ) {
                if (document.getElementById("item" + j)) {
                  let id = "#item" + j;
                  let itemBox = $(id);
                  itemBox.parent(".itemBox").css("border", "solid 3px #0d446f");
                }
              }
            }
          }
        }
      }
    },
    //リードタイムの計算(radioのdisplay-classの付与)
    isEnough: function(kikaku) {
      if (kikaku.boolean) {
        return false;
      } else {
        return true;
      }
    },
    //カートの表示・非表示
    showCart: function() {
      this.$emit("showCart");
    },
    hideCart: function() {
      this.$emit("hideCart");
    },
    //カートの中身の表示・非表示
    showCartContents: function(item) {
      this.$emit("showCartContents", item);
    },
    //商品一覧のサムネイル画像のクリック時の処理
    thumImgClick: function(src) {
      this.reservation.item.images.main = src;
    },
    //もっとみるボタンの表示・非表示
    checkSeen: function() {
      this.$emit("checkSeen");
    },
    //カテゴリー検索（全選択）
    selectAll: function() {
      this.$emit("selectAll");
      this.showNoItemText();
    },
    //カテゴリー検索（カテゴリー別）
    selectCat: function(catId, catName) {
      this.$emit("selectCat", catId, catName);
      this.showNoItemText();
    },
    openModal: function(item, index) {
      let modal = document.getElementById("modal");
      modal.style.display = "block";
      this.reservation.item.name = item.title.rendered;
      this.reservation.item.original = item.title.rendered;
      this.reservation.item.price = item.acf.price;
      this.reservation.item.cat = item._embedded["wp:term"][0][0].name;
      this.reservation.item.desc = item.acf.description;
      this.reservation.item.images.main = item.acf.images[0].image.sizes.medium;
      this.reservation.item.images.reserMain =
        item.acf.images[0].image.sizes.medium;
      this.reservation.item.images.thum = {};
      for (let i = 0; i < item.acf.images.length; i++) {
        this.reservation.item.images.thum[i] =
          item.acf.images[i].image.sizes.medium;
      }
      //規格・サイズの取得
      this.reservation.item.kikaku = item.acf.kikaku;
      for (let i = 0; i < this.reservation.item.kikaku.length; i++) {
        if (this.reservation.item.kikaku[i].kikaku_size === "") {
          this.reservation.item.kikaku[i].kikaku_size = "サイズなし";
        }
      }
      // 予約時の商品ごとの番号（postId）
      this.reservation.item.reserId = item.id;
      //枠をつける（IDの取得）
      let item_select_id = "item" + index;
      this.reservation.item.id = item_select_id;
      // サムネイルを表示するか非表示にするか判定（サムネイルが１個以下なら非表示）
      if (Object.keys(this.reservation.item.images.thum).length <= 1) {
        this.thumDisplay = false;
      }
    },
    resetForm: function() {
      // inputの状態を初期値に戻す
      const number = document.getElementById("number");
      //      const message = document.getElementById('message')
      //      const candleBig = document.getElementById('candleBig')
      //      const candleSmall = document.getElementById('candleSmall')

      if (number) {
        number.value = 1;
      }
      //      if (message) {
      //        message.value = ''
      //      }
      //      if (candleBig) {
      //        candleBig.options[0].selected = true
      //      }
      //      if (candleSmall) {
      //        candleSmall.options[0].selected = true
      //      }
    },
    closeModal: function() {
      // inputの状態を初期値に戻す
      this.resetForm();

      let modal = document.getElementById("modal");
      modal.style.display = "none";
      //labelのcurrent表示をもとに戻す
      let kikakuLabel = document.getElementsByClassName("kikakuLabel");
      for (let i = 0; i < kikakuLabel.length; i++) {
        kikakuLabel[i].classList.remove("current");
      }
      kikakuLabel[0].classList.add("current");
    },
    cartIn: function(catName) {
      ///////////////////////////////////////////////////////////////////////////
      //alertを出す
      let number_alert = document.getElementById("number").value;
      let maxItemNumber =
        parseInt(number_alert, 10) +
        parseInt(this.reservation.totalCartItemNumber, 10);
      // if (maxItemNumber > 3) {
      //   alert('一度に予約できる商品の個数は３つまでです。')
      //   return
      // }
      ///////////////////////////////////////////////////////////////////////////

      //最初に名前の取得(商品名でカートの中身を検索するため)
      let kikakuName = document.getElementsByName("kikaku");
      for (let i = 0; i < kikakuName.length; i++) {
        if (kikakuName[i].checked) {
          this.reservation.item.name += kikakuName[i].value;
        }
      }
      //重複チェック
      for (let i = 0; i < this.reservation.cart.length; i++) {
        //重複があった場合、個数等だけ増加させてreturn
        if (this.reservation.cart[i].name === this.reservation.item.name) {
          let number = document.getElementById("number");
          if (
            this.reservation.cart[i].cat === "ホールケーキ" ||
            this.reservation.cart[i].cat === "季節のイベントケーキ"
          ) {
            //            let candleBig = document.getElementById('candleBig')
            //            let candleSmall = document.getElementById('candleSmall')
            //ろうそくの数を追加！
            //            this.reservation.cart[i].candle.big += parseInt(candleBig.value,10)
            //            this.reservation.cart[i].candle.small += parseInt(candleSmall.value,10)
            //メッセージの取得
            //            let message = document.getElementById('message')
            //            this.reservation.cart[i].message = message.value
          }
          //個数を取得
          this.reservation.cart[i].number =
            parseInt(number.value, 10) +
            parseInt(this.reservation.cart[i].number);
          this.reservation.sum +=
            parseInt(number.value, 10) * this.reservation.cart[i].price;

          //終了後モーダルを閉じる！
          let modal = document.getElementById("modal");
          modal.style.display = "none";
          let modalCart = document.getElementById("modalCart");
          modalCart.style.display = "block";
          //カート内の総個数
          this.reservation.totalCartItemNumber += parseInt(number.value, 10);
          this.returnAppSum();
          return;
        }
      }
      //重複がなかった場合（カートの中身を増やす）
      this.reservation.cart[this.reservation.count] = {
        name: "",
        price: "",
        number: "",
        image: {},
        cat: "",
        id: "",
        original: "",
        reserId: "",
      };
      //名前のセット(規格・サイズと合成)
      this.reservation.cart[
        this.reservation.count
      ].name = this.reservation.item.name;
      this.reservation.cart[
        this.reservation.count
      ].original = this.reservation.item.original;
      //金額のセット
      for (let i = 0; i < kikakuName.length; i++) {
        if (kikakuName[i].checked) {
          for (let j = 0; j < this.reservation.item.kikaku.length; j++) {
            if (
              this.reservation.item.kikaku[j].kikaku_size == kikakuName[i].value
            ) {
              this.reservation.cart[
                this.reservation.count
              ].price = this.reservation.item.kikaku[j].kikaku_price;
            }
          }
        }
      }
      this.reservation.cart[
        this.reservation.count
      ].image = this.reservation.item.images.reserMain;
      this.reservation.cart[
        this.reservation.count
      ].cat = this.reservation.item.cat;
      this.reservation.cart[
        this.reservation.count
      ].id = this.reservation.item.id;
      this.reservation.cart[
        this.reservation.count
      ].reserId = this.reservation.item.reserId;

      //個数の取得
      let number = document.getElementById("number");
      this.reservation.cart[this.reservation.count].number = number.value;
      //カート内の総個数
      this.reservation.totalCartItemNumber += parseInt(
        this.reservation.cart[this.reservation.count].number,
        10
      );
      //this.reservation.sumの計算
      this.reservation.sum +=
        this.reservation.cart[this.reservation.count].price *
        this.reservation.cart[this.reservation.count].number;
      if (
        this.reservation.item.cat === "ホールケーキ" ||
        this.reservation.item.cat === "季節のイベントケーキ"
      ) {
        //ろうそくの数の取得
        //        let candleBig = document.getElementById('candleBig')
        //        this.reservation.cart[this.reservation.count].candle.big = parseInt(candleBig.value,10)
        //        let candleSmall = document.getElementById('candleSmall')
        //        this.reservation.cart[this.reservation.count].candle.small = parseInt(candleSmall.value,10)
        //メッセージの取得
        //        let message = document.getElementById('message')
        //        this.reservation.cart[this.reservation.count].message = message.value
        this.$forceUpdate();
      }
      // inputの状態を初期値に戻す
      this.resetForm();

      //終了後モーダルを閉じる！
      let modal = document.getElementById("modal");
      modal.style.display = "none";

      //カウントを増やす！
      this.reservation.count++;

      //カートのモーダルを表示
      let modalCart = document.getElementById("modalCart");
      modalCart.style.display = "block";

      //カートのボタンを表示
      let modalCartBtn = document.getElementById("pageHeaderCartBtn");
      modalCartBtn.style.display = "block";

      //商品リストに枠をつける
      let item_select = document.getElementById(this.reservation.item.id);
      item_select.classList.add("border_blue");

      this.returnAppSum();

      //labelのcurrent表示をもとに戻す
      let kikakuLabel = document.getElementsByClassName("kikakuLabel");
      for (let i = 0; i < kikakuLabel.length; i++) {
        kikakuLabel[i].classList.remove("current");
      }
      kikakuLabel[0].classList.add("current");
    },
    //小計の計算
    sum: function() {
      this.reservation.hiddenSum = 0;
      this.reservation.tax = 0;
      let sum = 0;
      let hiddenSum = document.getElementsByClassName("hiddenSum");
      for (let i = 0; i < hiddenSum.length; i++) {
        sum += parseInt(hiddenSum[i].textContent, 10);
        this.reservation.hiddenSum = sum;
      }
    },
    //カートのitem削除
    deleCartItem: function(index) {
      //枠の変数
      let originalName = this.reservation.cart[index].original;
      let originalId = this.reservation.cart[index].id;
      let selectFlag = false;
      this.reservation.totalCartItemNumber -= parseInt(
        this.reservation.cart[index].number,
        10
      );
      this.reservation.cart.splice(index, 1);
      this.reservation.count--;
      this.reservation.hiddenSum = 0;
      this.reservation.tax = 0;
      let sum = 0;
      let hiddenSum = document.getElementsByClassName("hiddenSum");
      this.reservation.sum -= parseInt(hiddenSum[index].textContent, 10);
      if (this.reservation.cart.length === 0) {
        this.closePopUpCart();
        let modalCartBtn = document.getElementById("pageHeaderCartBtn");
        modalCartBtn.style.display = "none";
      }
      this.returnAppSum();
      //商品一覧の枠を消す
      for (let i = 0; i < this.reservation.cart.length; i++) {
        if (this.reservation.cart[i].origin === originalName) {
          selectFlag = true;
          //trueの場合は枠線を削除する必要なし
          if (selectFlag) {
            break;
          }
        }
      }
      if (!selectFlag) {
        let item_select = $("#originalId");
        item_select.parent(".itemBox").css("border", "solid 3px transparent");
        item_select.removeClass("border_blue");
      }
    },
    //カートのポップアップの非表示
    closePopUpCart: function() {
      let modalCart = document.getElementById("modalCart");
      modalCart.style.display = "none";
    },
    //用意できる商品が存在しない場合
    showNoItemText: function() {
      if (this.reservation.showItemList.length === 0) {
        this.seenNoItemtext = true;
      } else {
        this.seenNoItemtext = false;
      }
    },
    returnAppSum: function() {
      this.$emit("returnAppSum", this.reservation.totalCartItemNumber);
    },
    //カートモーダルのろうそく等の出し分け
    seenInCartContents: function(itemCart) {
      if (
        itemCart.cat === "ホールケーキ" ||
        itemCart.cat === "季節のイベントケーキ"
      ) {
        return true;
      } else {
        return false;
      }
    },
    /////////////////////////////////////////////////////////////////////////////////
    //商品選択のモーダルーraidioボタン選択時のクラス付与！
    radioAddClass: function(index) {
      let kikakuLabel = document.getElementsByClassName("kikakuLabel");
      for (let i = 0; i < kikakuLabel.length; i++) {
        kikakuLabel[i].classList.remove("current");
      }
      kikakuLabel[index].classList.add("current");
    },
    labelCurrrentCheck: function(index) {
      if (index === 0) {
        return true;
      }
    },
    /////////////////////////////////////////////////////////////////////////////////
  },
};
</script>

<style scoped lang="scss">
a {
  color: #000;
  &hover {
    opacity: 0.7;
    cursor: pointer;
  }
}
.active {
  background-color: #0d446f !important;
}
.btn {
  text-align: center;
  display: block;
  margin-top: 30px;
  padding: 15px 0;
  background-color: #831f17;
  color: #fff;
  width: 80%;
  position: relative;
  @media (max-width: 767.98px) {
    margin: 30px auto;
    width: 100%;
  }
  i {
    color: #fff;
    text-align: right;
    margin-left: 10px;
  }
  &_blue {
    background-color: #0d446f;
    i {
      margin-left: 0;
      margin-right: 10px;
    }
  }
  &:hover {
    opacity: 0.7;
    cursor: pointer;
  }
}
.step3 {
  // display: flex;
  padding: 0 15px;
  &--main {
    width: 100%;
    //カテゴリー選択のボタン
    .selectCat {
      display: flex;
      align-content: center;
      margin-bottom: 10px;
      @media (max-width: 767.98px) {
        display: block;
      }
      &__text1 {
        margin-bottom: 0;
        margin-top: 3px;
        margin-right: 15px;
        margin-left: 5px;
        font-size: 14px;
        font-weight: 500;
        line-height: 1.64;
        color: #333333;
        width: 30%;
        @media (max-width: 767.98px) {
          width: 100%;
          text-align: center;
          margin-bottom: 10px;
        }
      }
      &BtnBox {
        display: flex;
        flex-wrap: wrap;
        @media (max-width: 767.98px) {
          margin-left: 8px;
        }
        .category {
          font-size: 14px;
          padding: 3px 10px;
          background-color: #ccc;
          color: #fff;
          border: none;
          border-radius: 50px;
          margin-right: 10px;
          margin-bottom: 4px;
          @media (max-width: 767.98px) {
          }
          &:hover {
            opacity: 0.7;
            cursor: pointer;
          }
        }
      }
    }
    //商品一覧
    .itemList {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .itemBox {
        width: 19%;
        padding: 0;
        padding-bottom: 10px;
        border: #d8d8d8 solid 1px;
        margin-bottom: 5px;
        &.none {
          height: 0;
          margin: 0;
          padding: 0;
          border: none;
        }
        @media (max-width: 767.98px) {
          width: 32%;
        }
        &:hover {
          opacity: 0.7;
          cursor: pointer;
        }
        &--imgBlock {
          position: relative;
          margin-bottom: 6px;
          min-height: 100px;
          overflow: hidden;
          &--img {
            max-width: 100%;
          }
          i {
            position: absolute;
            top: 0px;
            right: 0px;
            z-index: 10;
            font-size: 13.5px;
            font-weight: bold;
            line-height: 1.26;
            text-align: center;
            color: #ffffff;
            background-color: #0d446f;
            padding: 5px;
          }
        }
        &--categoryName {
          padding: 2px 7px;
          border-radius: 50px;
          background-color: #0d446f;
          font-size: 9px;
          font-weight: 500;
          line-height: 1.7;
          text-align: center;
          color: #ffffff;
          margin-bottom: 0;
        }
        &--itemName {
          font-size: 12px;
          font-weight: 500;
          line-height: 1.42;
          text-align: center;
          color: #333333;
          margin-top: 5px;
          margin-bottom: 5px;
        }
        &--itemPrice {
          font-size: 14px;
          font-weight: 500;
          line-height: 1.21;
          text-align: center;
          color: #333333;
          margin-bottom: 0;
        }
      }
    }
  }
}

#modal {
  display: none;
  background: rgba(0, 0, 0, 0.4);
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 10;
  @media (max-width: 767.98px) {
    overflow-y: auto;
  }
  &--whiteBlock {
    position: absolute;
    top: 10vh;
    left: 0;
    right: 0;
    width: 80%;
    margin: auto;
    margin-bottom: 50px;
    background: #fff;
    z-index: 20;
    @media (min-width: 1200px) {
      width: 60%;
    }
    @media (max-width: 767.98px) {
      width: 90%;
      top: 50px;
    }
  }
  &--contents {
    position: relative;
    .stopButton {
      position: absolute;
      top: -20px;
      right: 5px;
      margin-top: 0;
      font-size: 40px;
      @media (max-width: 767.98px) {
        font-size: 30px;
        top: -5px;
      }
      &:hover {
        cursor: pointer;
      }
    }
    .modal--content {
      display: flex;
      @media (max-width: 767.98px) {
        display: block;
      }
      &Img {
        width: 35%;
        @media (max-width: 767.98px) {
          width: 90%;
          margin: auto;
        }
        &--main {
          width: 100%;
          height: auto;
          object-fit: contain;
        }
        &--thum {
          display: flex;
          flex-wrap: wrap;
          max-width: 100%;
          img {
            width: 33%;
            max-height: 100px;
            height: auto;
            object-fit: cover;
            padding: 3px;
            cursor: pointer;
            @media (min-width: 1200px) {
              max-height: 120px;
            }
            @media (max-width: 991.98px) {
              max-height: 70px;
            }
            @media (max-width: 767.98px) {
              max-height: 170px;
            }
            @media (max-width: 575.98px) {
              max-height: 90px;
            }
          }
        }
      }
      &Form {
        width: 65%;
        padding-left: 18px;
        @media (max-width: 767.98px) {
          width: 100%;
          padding-left: 0;
          margin-right: 0;
          margin-top: 30px;
        }
        @media (max-width: 575.98px) {
          margin-top: 15px;
        }
        &__desc {
          font-size: 12px;
        }
        &__number {
          border-bottom: 1px #ccc solid;
          padding-bottom: 8px;
          display: flex;
          align-items: center;
          &--label {
            display: flex;
            margin-right: 10px;
            margin-bottom: 0;
            text-align: left;
            font-size: 14px;
            font-weight: 500;
            line-height: 2.21;
            text-align: left;
            color: #333333;
            @media (max-width: 767.98px) {
            }
          }
          &--input {
            // margin-left: 100px;
            margin-left: 30px;
            margin-right: 15px;
            border-radius: 3px;
            background-color: #ffffff;
            border: solid 1px #cccccc;
            text-align: center;
            max-width: 70px;
            @media (max-width: 767.98px) {
              // margin-left: 100px;
            }
            &.form-control {
              width: auto;
            }
          }
          &_input {
            display: flex;
            width: 15%;
          }
        }
      }
    }
  }
}
.modal {
  overflow-y: scroll;
  &__contents {
    margin: 50px 30px;
    @media (max-width: 767.98px) {
      width: 90%;
      margin: 20px auto;
    }
    &--itemName {
      font-size: 21px;
      font-weight: 500;
      line-height: 1.48;
      text-align: left;
      color: #333333;
      @media (max-width: 767.98px) {
        padding-top: 35px;
      }
      @media (max-width: 575.98px) {
        padding-top: 20px;
      }
    }
  }
  @media (max-width: 575.98px) {
    .btn {
      margin: 10px 0;
    }
  }
  &--content {
    &Form {
      &__candle {
        border-bottom: 1px #ccc solid;
        padding-top: 8px;
        padding-bottom: 8px;
        margin-bottom: 15px;
        display: flex;
        @media (max-width: 767.98px) {
          display: block;
        }
        .div {
          display: flex;
        }
        &--text1 {
          font-size: 14px;
          font-weight: 500;
          line-height: 2.21;
          text-align: left;
          color: #333333;
          margin-right: 30px;
          @media (max-width: 767.98px) {
            margin-right: 15px;
          }
        }
        &--text2 {
          font-size: 14px;
          font-weight: 500;
          line-height: 2.21;
          text-align: left;
          color: #333333;
          margin-right: 5px;
        }
        .inputNumber {
          display: inline-block;
          &.form-control {
            width: auto;
          }
        }
      }
      &__msg {
        border-bottom: 1px #ccc solid;
        padding-bottom: 8px;
        display: flex;
        align-items: center;
        @media (max-width: 767.98px) {
          display: block;
        }
        &--label {
          width: 33%;
          font-size: 14px;
          font-weight: 500;
          line-height: 1.43;
          text-align: left;
          color: #333333;
          margin-bottom: 0;
          @media (max-width: 767.98px) {
            width: 100%;
            border-bottom: 0;
            padding-bottom: 8px;
            margin-bottom: 0;
          }
        }
        &--input {
          width: 67%;
          border-radius: 3px;
          background-color: #ffffff;
          border: solid 1px #cccccc;
          font-size: 14px;
          font-weight: 500;
          line-height: 1.64;
          text-align: left;
          padding: 5px;
          @media (max-width: 767.98px) {
            width: 100%;
            border-bottom: 1px #ccc solid;
            padding-bottom: 8px;
            margin-bottom: 10px;
          }
        }
      }
    }
  }
}
.modal_cart {
  display: none;
  background: rgba(0, 0, 0, 0.4);
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 10;
  overflow-y: scroll;
  &_white {
    background: #fff;
    position: absolute;
    position: absolute;
    top: 100px;
    left: 0;
    right: 0;
    width: 80%;
    margin: auto;
    margin-bottom: 80px;
    z-index: 20;
    @media (min-width: 1200px) {
      width: 60%;
    }
    @media (max-width: 767.98px) {
      width: 90%;
      top: 50px;
    }
  }
  .stopButton {
    position: absolute;
    top: 10px;
    right: 15px;
    margin-top: 0;
    font-size: 40px;
    &:hover {
      cursor: pointer;
    }
  }
  .step3--cart {
    a {
      width: 30%;
      text-align: center;
      margin: auto;
      display: block;
    }
    padding: 0 10px;
    margin-top: 30px;
    &__title {
      border-bottom: 1px gray solid;
      padding-bottom: 30px;
      margin-bottom: 0;
    }
    &--list {
      position: relative;
      padding-top: 15px;
      border-bottom: 1px gray solid;
      display: flex;
      @media (max-width: 767.98px) {
        padding-top: 55px;
      }
      .hiddenSum {
        display: none;
      }
      &__img {
        width: 30%;
      }
      &__price {
        width: 70%;
        margin-left: 30px;
        @media (max-width: 575.98px) {
          margin-left: 10px;
        }
        &--number {
          font-size: 14px;
          font-weight: 500;
          line-height: 1.5;
          text-align: left;
          color: #333333;
        }
      }
      &__dele {
        position: absolute;
        top: 50%;
        margin-top: -20px;
        right: 0px;
        border-radius: 50px;
        background-color: #cccccc;
        padding: 10px 25px;
        @media (max-width: 767.98px) {
          font-size: 12px;
          top: 30px;
        }
        &:hover {
          cursor: pointer;
          opacity: 0.7;
        }
      }
    }
    &__sum {
      font-size: 13px;
      font-weight: 500;
      line-height: 2.15;
      text-align: left;
      color: #333333;
      p {
        text-align: right;
        margin-top: 5px;
        margin-bottom: 10px;
      }
      span {
        font-size: 21px;
        font-weight: 500;
        line-height: 1.33;
        text-align: right;
        color: #333333;
      }
    }
  }
  .btnBox {
    display: flex;
    margin: 30px;
    @media (max-width: 767.98px) {
      display: block;
    }
    button {
      margin: 5px;
    }
  }
}
.label_kikaku {
  border-bottom: 1px solid #ccc;
  &__p {
    margin-top: 15px;
    margin-bottom: 15px;
    input,
    label {
      cursor: pointer;
    }
    &.form-control {
      width: auto;
    }
  }
}
//枠線
.border_blue {
  // border: solid 3px #0d446f !important;
  // border: solid 3px #fff !important;
}
.d_none {
  display: none !important;
}
//labelのスタイル
.kikakuLabel {
  display: flex;
  align-items: center;
  &:hover,
  &:focus,
  &:active {
    cursor: pointer;
  }
  &.current {
    .kikakuLabel__txt {
      background-color: #f5f5f5;
    }
  }
  &__txt {
    padding: 0 10px;
  }
  input {
    margin-right: 10px;
    margin-top: -2px;
    display: block;
  }
}
//サイズの注意書き
.noticeSize {
  font-size: 15px;
  text-align: center;
  border: 1px solid #000;
  padding: 10px 5px;
  // margin-bottom: 30px;

  ul {
    margin-top: 15px;
    margin-bottom: 0;
    text-align: left;
    font-size: 13px;
    list-style: none;
    padding: 0 20px;
    display: flex;
    flex-wrap: wrap;
    @media (max-width: 767.98px) {
      margin-top: 10px;
    }
    @media (max-width: 575.98px) {
      padding: 0 5px;
    }
    li {
      width: 50%;
      margin-bottom: 5px;
      @media (max-width: 767.98px) {
        width: 100%;
      }
    }
  }
}

.not-display-soldout {
  display: inline-block;
  margin: 5px 0 30px;
}

.numberNotice {
  font-size: 12px;
  margin: 5px 0;
}
.catBtn {
  border: 1px #000 solid !important;
  color: #000 !important;
  &.active {
    color: #fff !important;
  }
}
</style>
